<template>
  <div class="container personal-form tw-px-4 lg:tw-pt-20 lg:tw-pb-5 tw-pb-48" v-if="!isSend">
    <ValidationObserver v-slot="{ invalid }">
      <title-section
        title="Datos personales"
        subtitle="Rellena el formulario con tus datos y nos pondremos en contacto contigo."
      ></title-section>
      <form
        @submit.prevent="onSubmit"
        class="tw-flex tw-mt-8 tw-mb-0 tw-flex-col tw-justify-center"
      >
      <div class="tw-flex lg:tw-flex-row tw-flex-col tw-justify-between tw-mt-8">
        <ValidationProvider
          name="Nombre"
          rules="required"
          v-slot="{ errors }"
          class="tw-w-full lg:tw-mr-8 tw-flex tw-flex-col"
        >
          <label class="tw-pb-4">Nombre</label>
          <input
            v-model="form.firstName"
            class="input-slot tw-w-full"
            type="text"
          />
          <span class="tw-text-red-500">{{ errors[0] }}</span>
        </ValidationProvider>
        <ValidationProvider
          name="Apellido"
          rules="required"
          v-slot="{ errors }"
          class="tw-w-full tw-lg:mr-5 tw-flex tw-flex-col lg:tw-mt-0 tw-mt-8"
        >
          <label class="tw-pb-4">Apellido</label>
          <input
            v-model="form.lastName"
            class="input-slot tw-w-full"
            type="text"
          />
          <span class="tw-text-red-500">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
        <div class="tw-flex lg:tw-flex-row tw-flex-col tw-justify-between tw-mt-8">
          <ValidationProvider
            name="Email"
            rules="required|email"
            class="tw-w-full lg:tw-mr-8 tw-flex tw-flex-col"
            v-slot="{ errors }"
          >
            <label class="tw-pb-4">Email*</label>
            <input v-model="form.email" class="input-slot" type="email" />
            <span class="tw-text-red-500">{{ errors[0] }}</span>
          </ValidationProvider>
          <ValidationProvider
            name="Teléfono"
            class="tw-w-full lg:tw-mt-0 tw-mt-8"
            rules="required|digits:9"
            v-slot="{ errors }"
          >
            <label>Teléfono*</label>
            <input v-model="form.phone" class="input-slot tw-mt-4" type="text" />
            <span class="tw-text-red-500">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <ValidationProvider
          name="Politica de Privacidad"
          rules="required"
          class="tw-mr-8"
          v-slot="{ errors }"
        >
          <input v-model="form.checkbox" id="privacity" class="form-check-input" type="checkbox">
          <label for="privacity" class="form-check-label tw-text-small tw-relative tw-pl-8">
            <p class="tw-text-left tw-mb-2">Con el envío de mis datos personales confirmo que he leído y aceptado la política de privacidad.</p>
          </label>
          <span class="tw-text-red-500">{{ errors[0] }}</span>
        </ValidationProvider>
      </form>
      <div class="fixed-button-mobile tw-mt-8">
        <button
          @click="onSubmit"
          class="btn btn-primary fixed-button btn-steps tw-flex tw-items-center tw-justify-center"
          :class="!invalid && form.email && form.firstName && form.lastName && form.phone && form.checkbox ? 'active' : 'disabled-button'"
        >
          <span v-if="!loading">Solicitar información</span>
          <clip-loader v-else color="#ffffff"></clip-loader>
        </button>
      </div>
    </ValidationObserver>
  </div>
  
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from "vee-validate";
import axios from "axios";
import { mapGetters} from "vuex";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

// install rules and localization

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ClipLoader,
  },
  data: () => ({
    form: {
      email: "",
      firstName: "",
      lastName: "",
      phone: "",
      checkbox: false,
    },
    invalid: true,
    loading: false,
    isSend: false
  }),
  computed: {
    ...mapGetters({
      wizard: "getWizard",
    }),
    wizardInfo() {
      var wizardInfo = this.wizard;

      wizardInfo = {
        ...wizardInfo,
      };
      return wizardInfo;
    },
  },
  methods: {

    onSubmit() {
      this.loading = true;
      console.log('submit')
      axios
        .post("/api/wizard", {
          data: this.form,
          wizardInfo: this.wizardInfo,
        })
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.isSend = true;
          this.$router.push({ name: "Confirm" });
          // let steps = document.getElementById("wizard-steps");
          // steps.classList.add("hidden-steps");
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import '../../../sass/_variables.scss';

.personal-form {
  margin: auto;
  max-width: 565px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 992px) {
    justify-content: space-between;
  }

  .v-clip {
    height: 18px !important;
    width: 18px !important;
  }
  .btn.btn-primary {
    border-radius: 6px;
    background-color: $color-grey-hover;
    &.active {
      background-color: $primary;
    }
    &.disabled-button {
      pointer-events: none;
    }
  }
  .fixed-button {
    width: 100%;
    height: 48px;
    @media (max-width: 1023px) {
      height: 50px !important;
    }
  }

  input[type="checkbox"] {
    visibility: hidden;
  }
  input[type="checkbox"] + label {
    display: block;
    cursor: pointer;
    margin-left: 2rem;
    p:first-child {
        padding-left: 1rem;
        margin-left: -1rem;
    }
  }
  input[type="checkbox"] + label:before {
    border: 1px solid $border-chip;
    border-radius: 6px;
    content: "\00a0";
    display: inline-block;
    font: 14px/1em sans-serif;
    width: 20px;
    height: 20px;
    margin: 2px .25em 0 0;
    padding: 1px 1px 0 0;
    position: absolute;
    left: -2rem;
    padding-top: 3px;
    top: 1px;
  }
  input[type="checkbox"]:checked + label:before {
    background: $primary;
    border-color: $primary;
    color: $color-white;
    content: "\2713";
    text-align: center;
    font-weight: 600;
  }
  .btn-steps {
      @media(max-width: $lg){
          left: 3%;
      }
  }
  .fixed-button-mobile {
      @media (max-height: 830px) {
          justify-content: center;
          left: 0 !important;
      }
      @media(max-width: $lg){
          left: 3%;
      }
  }
}
.input-slot {
  width: 100%;
  height: 50px;
  border-radius: 6px;
  box-shadow: 0 6px 13px -5px rgba(129, 143, 166, 0.2);
  border: solid 0.5px $border-chip;
  background-color: $color-white;
  padding: 8px;

  @media (max-width: 1100px) {
    width: 100%;
  }
}

span.text-red-500 {
  color: $primary !important;
}

.width-200 {
  width: 200px !important;
}
.comfirm {
  @media (max-width: 992px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.content-confirm {
    width: 14rem;
    margin: 0 auto;
  .btn-contact {
  @media(min-width: $lg){
      min-width: 14rem !important;
      width: 0 !important;
    }
  }
}
</style>
